import React from 'react';
import { BuildingIcon, ClipboardListIcon, BarChart3Icon, SettingsIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface SidebarProps {
  isCollapsed: boolean;
  onToggle: () => void;
  onNavigate: (screen: 'order-form' | 'dashboard') => void;
  currentScreen: string;
}
export function Sidebar({
  isCollapsed,
  onToggle,
  onNavigate,
  currentScreen
}: SidebarProps) {
  const navItems = [{
    id: 'orders',
    label: 'Orders',
    icon: ClipboardListIcon,
    action: () => onNavigate('order-form')
  }, {
    id: 'agencies',
    label: 'Agencies',
    icon: BuildingIcon,
    action: () => onNavigate('order-form')
  }, {
    id: 'reports',
    label: 'Reports',
    icon: BarChart3Icon,
    action: () => {}
  }, {
    id: 'settings',
    label: 'Settings',
    icon: SettingsIcon,
    action: () => {}
  }];
  return;
}